import { AxiosResponse } from 'axios'
import { Moment } from 'moment'
import { IPaginatedResponse } from 'services/core/paginatedResponseCore'
import { RequestCDU, RequestREAD } from 'services/Instances'
import { IGetFiltroResponse } from './Syndicate'

export const ConventionServices = () => {
  const path = 'AcordoConvencao'

  const create = async (
    requestObj: ICreateConvention
  ): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/Salvar`, requestObj)

  const del = async (idAcordoConvencao: number): Promise<AxiosResponse<any>> =>
    await RequestCDU.delete(`${path}/Deletar/${idAcordoConvencao}`)

  const get = async (id: number): Promise<AxiosResponse<IConventionDetails>> =>
    await RequestREAD.get(`${path}/${id}`)

  const getAnexados = async (
    id: number
  ): Promise<AxiosResponse<IAcordoConvencaoAnexado>> =>
    await RequestREAD.get(`${path}/AdicionarNovo/GetAnexados`, {
      params: { idContrato: id }
    })

  const getById = async (id: number): Promise<AxiosResponse<any>> =>
    await RequestREAD.get(`${path}/AdicionarNovo/GetAcordoConvencao`, {
      headers: { idAcordoConvencao: id }
    })

  const getFiltro = async (
    requestObj: IFilterConvention
  ): Promise<AxiosResponse<IPaginatedResponse<IAcorcoConvencaoFiltro>>> =>
    await RequestREAD.post(`${path}/Pesquisar/Filtro`, requestObj)

  const getByRegistroHomologacao = async (cdHomologacao: string): Promise<AxiosResponse<IRegistroHomologDetails>> =>
    await RequestREAD.get(`${path}/AdicionarNovo/GetByRegistroHomologacao`, {
      headers: { cdHomologacao }
    })

  const getFillContract = async (
    requestObj: IFilterConvention
  ): Promise<AxiosResponse> =>
    await RequestREAD.post(`${path}/AdicionarNovo/GetCampos`, requestObj)

  const getContractByCd = async (cdContrato: string): Promise<AxiosResponse<IContrato>> =>
    await RequestREAD.get(`${path}/AdicionarNovo/FillCampos/Contrato`, {
      headers: { contrato: cdContrato }
    })

  const update = async (
    idAcordoConvencao: number,
    requestObj: ICreateConvention
  ): Promise<AxiosResponse> =>
    await RequestCDU.put(`${path}/Atualizar`, requestObj, {
      headers: { idAcordoConvencao: idAcordoConvencao }
    })

  return {
    create,
    del,
    get,
    getAnexados,
    getById,
    getContractByCd,
    getByRegistroHomologacao,
    getFillContract,
    getFiltro,
    update
  }
}

interface IContrato {
  cdContrato: string
  cnpjFornecedor: string
  competenciasDisponiveis: string[]
  idContrato: number
  idFornecedor: number
  nmFornecedor: string
}

export interface IFilterConvention {
  cdContrato?: string
  cnpjFornecedor?: string
  nmFornecedor?: string
  nmSindicato?: string
  cnpjSindicato?: string
  dtvigenciaInicio?: string
  dtvigenciaFim?: string
  flVencido?: string
  pageNumber?: number
  pageSize?: number
}

export interface IConvention {
  idAcordoConvencao: number
  cdContrato: string
  cnpjFornecedor: string
  nmFornecedor: string
  dtVigenciaInicio: string
  dtVigenciaFim: string
  flVencido: boolean
  qtdDias: number
  idContrato: number
  nuAnoMesCompetencia: string
}

export interface IFillContract {
  idContrato: number
  cdContrato: string
  nmFornecedor: string
  cnpjFornecedor: string
}

export interface ICreateConvention {
  txTipo: string
  contratoId: number
  fornecedorId: number
  cdHomologacao: string
  flValeAlimentacao: boolean
  flValeRefeicao: boolean
  flHorasExtras: boolean
  txObservacaoHorasExtras: string
  flBancoHoras: boolean
  txObservacaoBancoHoras: string
  flTurno: boolean
  txObservacaoTurno: string
  txObservacaoGeral: string
  dtVigenciaInicio: string
  dtVigenciaFim: string
  flVencido: boolean
  pePericulosidade: number
  pePisoSalarial: number
  peInsalubridade: number
  vlReajuste: number
  idsSindicato: any[]
  nuAnoMesCompetencia: string[]
}

export interface IRegistroHomologDetails {
  flValeAlimentacao: boolean
  flValeRefeicao: boolean
  flHorasExtras: boolean
  txObservacaoHorasExtras: string
  flBancoHoras: boolean
  txObservacaoBancoHoras: string
  flTurno: boolean
  txObservacaoTurno: string
  txObservacaoGeral: string
  dtVigenciaInicio: string
  dtVigenciaFim: string
  flVencido: boolean
  pePericulosidade: number
  pePisoSalarial: number
  peInsalubridade: number
  vlReajuste: number
  sindicatos: IGetFiltroResponse[]
}

export interface IConventionDetails {
  idAcordoConvencao: number
  txTipo: string
  contratoId: number
  fornecedorId: number
  nmFornecedor: string
  cnpjFornecedor: string
  cdHomologacao: string
  flValeAlimentacao: boolean
  flValeRefeicao: boolean
  flHorasExtras: boolean
  txObservacaoHorasExtras: string
  flBancoHoras: boolean
  txObservacaoBancoHoras: string
  flTurno: boolean
  txObservacaoTurno: string
  txObservacaoGeral: string
  dtVigenciaInicio: string
  dtVigenciaFim: string
  flVencido: boolean
  pePericulosidade: number
  pePisoSalarial: number
  peInsalubridade: number
  vlReajuste: number
  sindicatos: ISindicatos[]
  competenciasDisponiveis: string[]
}

export interface ISindicatos {
  idSindicato: number
  nmSindicato: string
  cnpjSindicato: string
}

export interface IAnexados {
  idMovDocumento: number
  idContrato: number
  cdGedExternalId: number
  txFileName: string
  txTipoPendencia: string
  nuAnoMesCompetencia: number
  dtAnexo: string
  idAcordoConvencao: number
  txTipo: string
  dtVigenciaInicio: string
  dtVigenciaFim: string
  flVencido: boolean
}

export interface IAcordoConvencaoAnexado {
  anexos: Anexo[]
  anexosPendentes: IAnexados[]
}

export interface Anexo {
  idMovDocumento: number
  idContrato: number
  cdGedExternalId: number
  txFileName: string
  txTipoPendencia: string
  nuAnoMesCompetencia: number
  dtAnexo: string
  idAcordoConvencao: number
  txTipo: string
  dtVigenciaInicio: string
  dtVigenciaFim: string
  flVencido: boolean
}

export interface IAcorcoConvencaoFiltro {
  idContrato: number
  idAcordoConvencao: number
  cdContrato: string
  cnpjFornecedor: string
  nmFornecedor: string
  dtVigenciaInicio: string
  dtVigenciaFim: string
  flVencido: boolean
  qtdDias: number
  nuAnoMesCompetencia: string
}
